import { useCallback, useEffect, useRef } from 'react'

import { useCurrentBlockIndex } from './document'

export const useScrollBlockIntoView = () => {
  const currentBlockIndex = useCurrentBlockIndex()
  const blockRefs = useRef<(any | null)[]>([])

  const scrollIntoView = useCallback(() => {
    if (currentBlockIndex === null || currentBlockIndex === -1) return

    blockRefs.current[currentBlockIndex]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    })
  }, [currentBlockIndex])

  useEffect(() => {
    const id = setTimeout(() => scrollIntoView(), 300)
    return () => clearTimeout(id)
  }, [scrollIntoView])

  return { blockRefs }
}
